import React from 'react';
import Chart from 'react-apexcharts';

const CardChart = ({ data }) => {
    
    const defaultStroke = data?.seriesData?.some((item) => Number(item) > 0);
    return (
      <div
        className={!defaultStroke ? "defsult-stroke-cricle" : ""}
        style={{ display: "flex", alignItems: "center",position: "relative" }}
      >
        {data && (
          <>
          <Chart
            options={data?.optionsData}
            series={data?.seriesData}
            type="donut"
            height={160}
          />
            {data?.centerLabel && (
              <div
                style={{
                  position: "absolute",
                  top: "60%",
                  left: "calc(48% - 60px)",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                  color: "#FFFFFF",
                  fontSize: "14px",
                  width: "90px",
                  wordBreak: "break-word",
                }}
              >
                {data.centerLabel}
              </div>
            )}
          </>
        )}
      </div>
    );
};

export default CardChart;
